import { path as typePath } from '../types';
import deepCopy from '../../../util/deepCopy';
import merge from 'deepmerge';

const initialState = {
    path: {
        callback: null,
        setup: null,
        queryErrors: [],
        lastPath: {
            fullPath: null,
            name: null,
            params: null
        }
    }
};
const state = deepCopy(initialState);

const getters = {
    [typePath.getters.get]: state => {
        return state.path === initialState ? null : state.path;
    }
};

const mutations = {
    [typePath.mutations.set]: (state, newPath) => {
        // TODO: Maybe only allow fields that are described in the path variable
        // Don't keep track of the queryErrors
        if (newPath.lastPath) {
            if (newPath.lastPath.queryErrors)
                delete newPath.lastPath.queryErrors;
            if (newPath.lastPath.params && newPath.lastPath.params.queryErrors)
                delete newPath.lastPath.params.queryErrors;
        }

        // For clients that have old states that still track the queryErrors
        if (state.path.lastPath) {
            if (state.path.lastPath.queryErrors)
                delete state.path.lastPath.queryErrors;
            if (state.path.lastPath.params && state.path.lastPath.params.queryErrors)
                delete state.path.lastPath.params.queryErrors;
        }

        // Don't merge path.queryErrors, overwrite them instead. Otherwise this array keeps growing.
        if (newPath.queryErrors)
            state.path.queryErrors = [];

        state.path = merge(state.path, newPath);
    },
    [typePath.mutations.reset]: state => {
        Object.keys(initialState).forEach(key => {
            state[key] = initialState[key];
        });
    },
    [typePath.mutations.clearErrors]: state => {
        state.path.queryErrors = [];
    }
};

const actions = {
    [typePath.actions.set]: (state, newPath) => {
        state.commit(typePath.mutations.set, newPath);
    },
    [typePath.actions.reset]: state => {
        state.commit(typePath.mutations.reset);
    },
    [typePath.actions.addQueryError]: (state, newQueryError) => {
        state.commit(typePath.mutations.set, {queryErrors: [newQueryError]});
    },
    [typePath.actions.clearErrors]: state => {
        state.commit(typePath.mutations.clearErrors);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
